export type BrandType =
  | "string"
  | "i8"
  | "i16"
  | "i32"
  | "i64"
  | "i128"
  | "i256"
  | "u8"
  | "u16"
  | "u32"
  | "u64"
  | "u128"
  | "u256"
  | "f32"
  | "f64"

type BrandInfo<TName extends string, TKind extends string> = {
  readonly __brand_name__: TName
  readonly __brand_kind__: TKind
}

export type Integer<
  TName extends string,
  T extends BrandType = "i64",
> = bigint & BrandInfo<TName, T>

export type Float<TName extends string, T extends BrandType = "f64"> = number &
  BrandInfo<TName, T>

export type String<TName extends string> = string & BrandInfo<TName, "string">
